import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import { useMe } from "./useMe";
import type { Workspace } from "../types";

export const WORKSPACES_KEY = ["workspaces"] as const;

export function useWorkspaces(): UseQueryResult<readonly Workspace[], ApiError> {
  const me = useMe();
  return useQuery<readonly Workspace[], ApiError>({
    queryKey: WORKSPACES_KEY,
    queryFn: ({ signal }) => apiFetch<readonly Workspace[]>("/api/me/workspaces", { signal }),
    enabled: !!me.data,
  });
}
